import apiClient from './apiClient';

class EmailService {
  async sendSupportEmail(formData) {
    try {
      const result = await apiClient.post('/api/support/ticket', {
        subject: formData.subject,
        message: formData.message,
        userEmail: formData.userEmail,
        userName: formData.userName,
        company: formData.company
      });

      return {
        success: true,
        message: 'Support ticket sent successfully!',
        ticketId: result.data?.ticketId
      };
    } catch (error) {
      throw new Error(error.message || 'Failed to send support ticket');
    }
  }
}

export default new EmailService();